import * as CubeTree from '../../cubeTree/index';

export function goodsIsValidate(cubeId: string): boolean {
    let cube: CubeNode = CubeTree.findByCubeId(cubeId);

    return !!(cube.goods && cube.goods[0]);
}
